// Palavras para o Modo Palavra Secreta
// Cada item tem: palavra (normal), palavraImpostor (diferente mas relacionada)
export const palavrasSecretas = [
  { id: 1, normal: "Lasanha", impostor: "Macarrão" },
  { id: 2, normal: "Aeroporto", impostor: "Rodoviária" },
  { id: 3, normal: "Hospital", impostor: "Farmácia" },
  { id: 4, normal: "Estádio", impostor: "Ginásio" },
  { id: 5, normal: "Praia", impostor: "Piscina" },
  { id: 6, normal: "Supermercado", impostor: "Mercadinho" },
  { id: 7, normal: "Cinema", impostor: "Teatro" },
  { id: 8, normal: "Academia", impostor: "Parque" },
  { id: 9, normal: "Biblioteca", impostor: "Livraria" },
  { id: 10, normal: "Elevador", impostor: "Escada" },
  { id: 11, normal: "Dentista", impostor: "Médico" },
  { id: 12, normal: "Piscina", impostor: "Lago" },
  { id: 13, normal: "Pizza", impostor: "Esfirra" },
  { id: 14, normal: "Sorvete", impostor: "Picolé" },
  { id: 15, normal: "Computador", impostor: "Notebook" },
  { id: 16, normal: "Avião", impostor: "Helicóptero" },
  { id: 17, normal: "Metrô", impostor: "Trem" },
  { id: 18, normal: "Cachorro", impostor: "Lobo" },
  { id: 19, normal: "Professor", impostor: "Tutor" },
  { id: 20, normal: "Casamento", impostor: "Noivado" },
  { id: 21, normal: "Carnaval", impostor: "Festa Junina" },
  { id: 22, normal: "Churrasco", impostor: "Espetinho" },
  { id: 23, normal: "Futebol", impostor: "Society" },
  { id: 24, normal: "Museu", impostor: "Galeria de Arte" },
  { id: 25, normal: "Banco", impostor: "Lotérica" },
];

// Pares para o Modo Duas Facções
// Cada item tem dois grupos opostos e uma palavra de impostor
export const paresFaccoes = [
  { id: 1, grupoA: "Pizza", grupoB: "Hambúrguer", impostor: "Cachorro-quente" },
  { id: 2, grupoA: "Praia", grupoB: "Montanha", impostor: "Campo" },
  { id: 3, grupoA: "Dia", grupoB: "Noite", impostor: "Amanhecer" },
  { id: 4, grupoA: "Gato", grupoB: "Cachorro", impostor: "Coelho" },
  { id: 5, grupoA: "Verão", grupoB: "Inverno", impostor: "Outono" },
  { id: 6, grupoA: "Café", grupoB: "Chá", impostor: "Suco" },
  { id: 7, grupoA: "Rock", grupoB: "Sertanejo", impostor: "Funk" },
  { id: 8, grupoA: "Netflix", grupoB: "Cinema", impostor: "YouTube" },
  { id: 9, grupoA: "Carro", grupoB: "Moto", impostor: "Bicicleta" },
  { id: 10, grupoA: "Cidade", grupoB: "Interior", impostor: "Litoral" },
  { id: 11, grupoA: "Introvertido", grupoB: "Extrovertido", impostor: "Ambiverso" },
  { id: 12, grupoA: "Futebol", grupoB: "Vôlei", impostor: "Basquete" },
  { id: 13, grupoA: "WhatsApp", grupoB: "Instagram", impostor: "Telegram" },
  { id: 14, grupoA: "Manhã", grupoB: "Noite", impostor: "Tarde" },
  { id: 15, grupoA: "Série", grupoB: "Filme", impostor: "Documentário" },
];

export function sortearPalavraSecreta() {
  return palavrasSecretas[Math.floor(Math.random() * palavrasSecretas.length)];
}

export function sortearFaccoes() {
  return paresFaccoes[Math.floor(Math.random() * paresFaccoes.length)];
}
